import { useEffect } from 'react';

// Orden = orden de menuDict[*].links en components/Header/index.jsx.
// Solo se listan los <li> con link directo; el <li> de "Portales" (dropdown) queda fuera
// porque no tiene un <a> hijo y el filtro de abajo lo descarta.
const NAV_KEYS = [
  'inicio',
  'ser_punto',
  'hop_para_tu_negocio',
  'conocenos',
  'contacto',
  'paqueteria'
];

const useLangMenuBar = (menu) => {
  useEffect(() => {
    if (!menu || typeof window === 'undefined') return;

    const nav = window.document.querySelector('header nav ul');
    if (nav) {
      const items = Array.from(nav.children).filter((li) => li.querySelector(':scope > a > p'));
      items.forEach((li, index) => {
        const key = NAV_KEYS[index];
        const p = li.querySelector(':scope > a > p');
        if (key && p && menu[key]) p.textContent = menu[key];
      });
    }

    const rastrea = window.document.querySelector('header a[href="/segui-tu-envio"] p');
    if (rastrea && menu.rastrea) rastrea.textContent = menu.rastrea;

    const puntos = window.document.querySelector(
      'header a[href="/conoce-los-puntos-hop"] p:last-of-type'
    );
    if (puntos && menu.conoce_puntos) puntos.textContent = menu.conoce_puntos;
  }, [menu]);
};

export default useLangMenuBar;
